export default __webpack_public_path__ + "static/media/charcuterie.ca026024.jpg";